// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, PropTypes, Status, Translate } from '@plesk/ui-library';

const ServiceStatus = ({ status, ...props }) => (
    <Status intent={status === 'running' ? 'success' : 'danger'}>
        <Translate content={`ServiceStatus.${status}`} />
    </Status>
);

ServiceStatus.propTypes = {
    status: PropTypes.oneOf([
        'invalid',
        'disabled',
        'starting',
        'running',
        'stopping',
        'stopped',
        'pausing',
        'paused',
        'continuing',
    ]).isRequired,
};

export default ServiceStatus;



// WEBPACK FOOTER //
// ./app/repair/ServiceStatus.js